import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Package } from "lucide-react";
import { Control } from "react-hook-form";
import { FormData } from "./schema";

interface ContentsCardProps {
  control: Control<FormData>;
}

export function ContentsCard({ control }: ContentsCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Package className="h-4 w-4" />
          Freight Contents
        </CardTitle>
        <CardDescription>
          Detailed description of the freight contents
        </CardDescription>
      </CardHeader>
      <CardContent>
        <FormField
          control={control}
          name="contents"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Contents Description *</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="Describe the freight contents, including item types, quantities, special handling requirements, etc."
                  className="min-h-[100px]"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}